{
  "form": {
    "required": "{name} is required",
    "incomplete": "Sorry, not all fields are filled out correctly.",
    "invalidPhoneNumber": "Invalid phone number",
    "phonePlaceholder": "Find international prefix",
    "oneRequired": "Only one of the fields is mandatory"
  },
  "orderFlow": {
    "error": {
      "description": "Something happened. Your order was incomplete. Please try again."
    },
    "confirmPayment": {
      "description": "You will be redirected to the payment gateway in a moment.",
      "redirectToGateway": "Redirect to payment gateway"
    },
    "complete": {
      "description": "Your order has been successfully completed.",
      "receiptIsReadyToDownload": "Your receipt is ready and you can download it to your device."
    },
    "showPaymentFailure": {
      "description": "Your payment was not completed successfully."
    },
    "waitForPayment": {
      "description": "We are waiting for the result of your payment."
    },
    "waitForReceipt": {
      "description": "We generate a receipt. Wait a minute."
    },
    "timeout": {
      "description": "The time limit has been exceeded. We will send you a notification of the result."
    }
  },
  "cancel": "Cancel",
  "no": "No",
  "yes": "Yes",
  "order": "Order",
  "emailAddress": "E-mail address",
  "phoneNumber": "Phone number",
  "somethingHappenedTryItAgain": "Something happened. Please try again.",
  "previousTab": "Previous",
  "nextTab": "Next",
  "goBack": "Go back",
  "download": "Download",
  "firstName": "First name",
  "lastName": "Last name",
  "companyName": "Company name",
  "regNum": "Registration No.",
  "regLocation": "Register Location",
  "vat": "VAT ID",
  "taxId": "Tax Number",
  "jobPosition": "Function / Position",
  "attentionTo": "Attention to",
  "street": "Street",
  "houseNum": "House Number",
  "city": "City",
  "zip": "Zip Code",
  "country": "Country",
  "accept": "Accept",
  "refuse": "Refuse",
  "localeSettings": {
    "title": "Language Settings",
    "localeSelect": "Use language"
  },
  "baasSimManagementLite": {
    "simAuthenticationFailed": "SIM Authentication failed",
    "simLoading": "SIM loading...",
    "noActivePackage": "No package",
    "availablePackages": "Available packages",
    "simLoadDataFailed": "Loading SIM data failed",
    "inactiveAndSynchronizationInProgress": "The SIM is not active. It can take up to 2 hours to synchronise the status.",
    "login": {
      "authorizationCode": "Authorization Code",
      "authorizationCodeValidation": "Authorization code is max 6 length alphanum code."
    },
    "loginType": {
      "go": "Go",
      "identificationCode": "Identification code",
      "insertSimIdentification": "Please insert SIM identification",
      "invalidIdentificationCode": "Invalid identification code"
    },
    "package": {
      "purchaseInProgress": "Purchase in progress",
      "buyFor": "Buy for",
      "inactiveAndSynchronizationInProgress": "The SIM is not active. It can take up to 2 hours to synchronise the status."
    },
    "packageOrder": {
      "description": "Before we redirect you to the payment gateway, please enter your email address to which we will send you proof of payment.",
      "requiredTermsAndConditions": "Before ordering a package you need to agree to the terms and conditions",
      "showBillingInfo": "Fill in billing information",
      "billingName": "Name"
    },
    "unprocessedPackages": {
      "foundUnprocessed": "The order is being processed. This operation may take a few minutes. Please wait.",
      "warnUnprocesse:": "The order is being processed. Are you sure you want to order another package?"
    },
    "usageBar": {
      "total": "Total",
      "used": "Used",
      "remaining": "Remaining",
      "validTo": "Valid to"
    }
  },
  "proposal": {
    "acceptForm": {
      "availableOffers": "Available offers",
      "companyInformations": "Company informations",
      "address": "Address",
      "contactPersonInformation": "Contact person information",
      "proposalAccpetFailed": "Acceptation of the proposal failed",
      "alternative": "Alternative",
      "comment": "Additional comment",
      "availableOffersHint": "Please select one or more offers to accept.",
      "tabs": {
        "offerAndCompany": "Offer and company",
        "addresses": "Addresses",
        "bankDetail": "Bank detail"
      },
      "personalCustomerPassword": {
        "label": "Personal customer password",
        "hint": "Required to verify your identity when contacting our support team"
      },
      "invoiceReceipt": {
        "title": "Invoice Recipient",
        "emailAddress": "E-Mail Adress for Invoice Recipient",
        "monthlyEmailNotificationNotIncludePDF": "The monthly email notification should not include a PDF copy of the e-invoice"
      },
      "billingAddress": {
        "title": "Billing Information",
        "sameAsCustomerInformation": "same as customer information"
      },
      "deliveryAddress": {
        "title": "Delivery address",
        "sameAsCustomerInformation": "same as customer information"
      },
      "adminAccessCredentials": {
        "title": "SIM Admin / Access Credentials for the Portal",
        "hint": "The SIM Admin is granted full access rights within the Portal. Additional users with different permission levels can be created by the SIM Admin.",
        "firstName": "SIM Admin First Name",
        "lastName": "SIM Admin Last Name",
        "jobPosition": "SIM Admin Function / Position",
        "phoneNumber": "SIM Admin Phone Number",
        "emailAddress": "SIM Admin E-mail"
      },
      "bankDetails": {
        "title": "Bank Details",
        "accountHolder": "Account Holder",
        "bankName": "Bank Name",
        "bic": "BIC",
        "iban": "IBAN",
        "street": "Street (Account Holder)",
        "postalCode": "Postal Code (Account Holder)",
        "city": "City (Account Holder)"
      },
      "companyVerification": {
        "title": "Company Verification",
        "hint": "Please provide at least one of the following: Unternehmensregister EUID or Trade License.",
        "euid": "Unternehmensregister EUID",
        "euidHelp": "European Unique Identifier (e.g. DEXXX...)",
        "tradeLicense": "Trade License (PDF)",
        "tradeLicenseHelp": "Upload your trade license as a PDF file",
        "validationRequired": "Please provide either an EUID or a Trade License",
        "invalidFileType": "Only PDF files are accepted"
      },
      "countOfSims": "The number of SIM cards ordered cannot be greater than three times the original order",
      "simsAmount": "Number of SIM cards",
      "differentSimsAmount": "Order a different number of SIM cards",
      "acceptProposal": "Accept proposal"
    },
    "refuseDialog": {
      "refuseDialogTitle": "Confirmation of refuse of the offer"
    },
    "refuseForm": {
      "reasonText": "Please state the reason for rejecting the offer",
      "refuseDialogText": "Are you sure you want to refuse proposal?",
      "proposalRefuseFailed": "Refuse of the proposal failed"
    },
    "proposalLoading": "Proposal loading...",
    "proposalLoadDataFailed": "Loading proposal data failed",
    "proposalIsAccepted": "The proposal is accepted",
    "proposalIsRefused": "The proposal is refused",
    "proposalExpired": "This proposal has expired",
    "proposalNumber": "Offer no.",
    "validTo": "Valid to"
  },
  "languages": {
    "en": "English",
    "cs": "Čeština",
    "sk": "Slovenský",
    "pl": "Polski",
    "de": "Deutsch"
  }
}
